// js/app/config refers to www.coursera.org. We need Labs-specific hostnames.
// eslint-disable-next-line no-restricted-syntax
export const LABS_HOSTNAME = 'hub.labs.coursera.org';

export const WORKSPACE_HOST_KEY = 'workspaceGatewayHost';
